/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Divider, Grid, Typography} from "@mui/material";
import BarraPc from "./BarraPc";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {theme} from "../../Tema";
import telefono from '../../Recursos/ic_telefono.svg'
import BarraCell from "./BarraCell";


const Barra = () => {
    const {masSM, sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,

                }}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        maxWidth: '1400px', px: 3, color: "#ffffff80", py: 0.5
                    }}
                >

                    <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14}}>
                            <span>
                                <img src={telefono} width={14} height={'auto'}
                                     style={{marginTop: 2, marginBottom: -2, marginRight: 5}}/>
                            </span>

                            {!sCell && 'Atención telefónica:'}

                            <span>
 (+57) 316 - 455 - 2822
                        </span>

                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                        <Grid
                            container
                            justifyContent={'flex-end'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}>


                            <Button sx={{color: '#ffffff80', fontSize: 14, py: 0, fontWeight: 400, px: sCell ? 0 : 4}}
                                    variant={'text'}>
                                Eres Empresa
                            </Button>
                            {!sCell &&

                                <>
                                    <Divider orientation="vertical" variant="middle" flexItem/>

                                    <Button sx={{color: '#ffffff80', fontSize: 14, py: 0, fontWeight: 400}}
                                            variant={'text'}>
                                        Eres Turista
                                    </Button>


                                    <Divider orientation="vertical" variant="middle" flexItem/>

                                    <Typography sx={{fontSize: 14, pl: 1.5}}>Email:
                                        info@hotelmarazultumaco.com</Typography>

                                </>
                            }

                        </Grid>
                    </Grid>

                </Grid>

            </Grid>

            {masSM ?
                <BarraPc/>
                :
                <BarraCell/>
            }


        </Grid>
    )

}
export default Barra    